import React from 'react';
import DottedLineLoader from './LoaderComponents/DottedLineLoader';

const ComponentLoader = () => {
  return <DottedLineLoader />;
};

export default ComponentLoader;
